import { __decorate } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
// import { objAny } from "@/common/common-interface";
let PiCard = class PiCard extends Vue {
};
__decorate([
    Prop({ default: "" })
], PiCard.prototype, "title", void 0);
__decorate([
    Prop({ default: true })
], PiCard.prototype, "headerShow", void 0);
__decorate([
    Prop({ default: false })
], PiCard.prototype, "flex", void 0);
__decorate([
    Prop({ default: "" })
], PiCard.prototype, "type", void 0);
PiCard = __decorate([
    Component({
        components: {},
    })
], PiCard);
export default PiCard;
